import React from 'react';
import {
    SystemMessageComponent,
    SystemMessageGraphic,
    SystemMessageSubtitle,
    SystemMessageTitle,
} from '@alfa-bank/newclick-composite-components/system-message';
import cn from 'classnames';
import { useAtomValue } from 'jotai';

import { ScrewdriverWrenchBoldMIcon } from '@alfalab/icons-glyph/ScrewdriverWrenchBoldMIcon';

import { platformAtom } from '../../atoms/platform/atom';

import styles from './index.module.css';

export const Error404 = () => {
    const platform = useAtomValue(platformAtom);

    return (
        <SystemMessageComponent
            className={cn(styles.error, styles[platform])}
            fullHeight={platform === 'mobile'}
        >
            <SystemMessageGraphic Icon={ScrewdriverWrenchBoldMIcon} />
            <SystemMessageTitle tag='h1'>Такой страницы нет</SystemMessageTitle>
            <SystemMessageSubtitle>
                Возможно, она была перемещена, или вы неверно указали ее адрес
            </SystemMessageSubtitle>
        </SystemMessageComponent>
    );
};
